import useSlackOAuthStart from './useSlackOAuthStart';
import { useCallback, useEffect, useRef, useState } from 'react';
import { isNil } from 'lodash';
import { SecondaryButton } from '../Button';
import { FieldLabel } from '../Form';
import styled from 'styled-components';

interface IProps {
  customButtonLabel?: string;
}

// Approximate time the authorization link is valid
const AUTH_URL_TTL_MS = 60_000;

const StyledFieldLabel = styled(FieldLabel)`
  display: inline;
`;

export const InstallSlackButton = ({
  customButtonLabel = 'Connect to Slack',
}: IProps) => {
  const { startSlackOAuth, startSlackOAuthLoading } = useSlackOAuthStart();
  const [authorizeUrl, setAuthorizeUrl] = useState<string | null>(null);

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const clearTimeoutRef = useCallback(() => {
    if (!isNil(timeoutRef.current)) {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  useEffect(() => () => clearTimeoutRef(), [clearTimeoutRef]);

  const handleClick = async () => {
    const authorizeUrl = await startSlackOAuth();
    setAuthorizeUrl(authorizeUrl);
    if (!isNil(authorizeUrl)) {
      window.open(authorizeUrl, '_blank');

      clearTimeoutRef();

      timeoutRef.current = setTimeout(() => {
        setAuthorizeUrl(null);
        timeoutRef.current = null;
      }, AUTH_URL_TTL_MS);
    }
  };

  return isNil(authorizeUrl) ? (
    <SecondaryButton
      onClick={handleClick}
      isOutlined
      disabled={startSlackOAuthLoading}
      trackContext="slack"
      trackAction="install"
    >
      {customButtonLabel}
    </SecondaryButton>
  ) : (
    <StyledFieldLabel>
      Slack authorization opened in a new window. If the window didn&apos;t
      open,{' '}
      <a href={authorizeUrl} target="_blank" rel="noopener noreferrer">
        click here
      </a>
      .
    </StyledFieldLabel>
  );
};
